import React, { useState,useEffect  } from 'react';
export default function Datatablenoresults () {
    return (
        <div className='my-5 py-5'>
            <div className='table-no-result mx-auto mb-4'></div>
            <div className='text-center fs-24 tc-13'>ไม่มีรายการ</div>
        </div>
    )
};